import { render, staticRenderFns } from "./eye-color-h5.vue?vue&type=template&id=3f71c5a0&scoped=true"
import script from "./eye-color-h5.vue?vue&type=script&lang=ts"
export * from "./eye-color-h5.vue?vue&type=script&lang=ts"
import style0 from "./eye-color-h5.vue?vue&type=style&index=0&id=3f71c5a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f71c5a0",
  null
  
)

export default component.exports